import httpClient from '@/api/httpClient'
import { defineStore } from 'pinia'
import { useMessagesStore } from '@/stores/messages'

export const useSectionsStore = defineStore('sections', {
  state: () => ({
    sections: [],
    fetchInitiated: false,
  }),

  getters: {
    all({ sections }) {
      return sections
    },

    enabled({ sections }) {
      return sections.filter(section => section.enabled)
    },

    enabledAsObject({ sections }) {
      return sections.filter(section => section.enabled).reduce((obj, section) => {
        obj[section.title] = section.id
        return obj
      }, {})
    },

    forIds: ({ sections }) => (ids) => {
      return sections.filter(section => ids.includes(section.id))
    },
  },

  actions: {
    async fetch() {
      this.fetchInitiated = true

      return httpClient.get('/api/internal/sections')
        .then(response => {
          this.sections = response.data.sections
        })
        .catch((err) => {
          useMessagesStore().smartAdd(err)
        })
    },

    async fetchOnce() {
      if (this.fetchInitiated) return Promise.resolve()

      return this.fetch()
    },
  },
})
